export default [
  {
    _name: "CSidebarNav",
    _children: [
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Dashboard',
      //   to: '/dashboard',
      //   icon: 'cil-speedometer',
      // },

      {
        _name: "CSidebarNavItem",
        name: "Users",
        icon: "cil-user",
        to: "/userList",
      },
      {
        _name: "CSidebarNavItem",
        name: "Add Quiz",
        icon: "cil-pencil",
        to: "/TableNft",
      },
      {
        _name: "CSidebarNavItem",
        name: "Quiz Points",
        icon: "cil-pencil",
        to: "/quizpoints",
      },
      {
        _name: "CSidebarNavItem",
        name: "Quiz Leaderboard",
        icon: "cil-pencil",
        to: "/quizleaderboard",
      },
      {
        _name: "CSidebarNavDropdown",
        name: "Game Points",
        // route: '/gamepoint',
        icon: "cil-cursor",
        items: [
          {
            name: "Game points",
            to: "/gamepoint",
          },
          {
            name: "New Game points",
            to: "/newGamePoint",
          },
          {
            name: "HTML Games",
            to: "/htmlGames",
          },
          {
            name: "Esports Games",
            to: "/esportsList",
          },
          {
            name: "Tournaments",
            to: "/tournaments",
          },
          // {
          //   name: "Tournaments user record",
          //   to: "/gametournamentindividual",
          // },
          {
            name: "Dino game points",
            to: "/dinopoint",
          },
          {
            name: "Tetris game points",
            to: "/tetrispoint",
          },
        ],
      },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'New NFT / Token',
      //   icon: 'cil-pencil',
      //   to: '/tokenEntry'
      // },

      // {
      //   _name: "CSidebarNavItem",
      //   name: "Token capture details",
      //   icon: "cil-cursor",
      //   to: "/tokenCollect",
      // },
      // {
      //   _name: "CSidebarNavItem",
      //   name: "Date wise details",
      //   icon: "cil-cursor",
      //   to: "/datewiseCapture",
      // },

      // {
      //   _name: "CSidebarNavItem",
      //   name: "Promocode",
      //   icon: "cil-pencil",
      //   to: "/promocode",
      // },
      // {
      //   _name: "CSidebarNavItem",
      //   name: "Promocode-users",
      //   icon: "cil-pencil",
      //   to: "/promocodeuser",
      // },
      {
        _name: "CSidebarNavItem",
        name: "Bannerupload",
        icon: "cil-pencil",
        to: "/bannerupload",
      },
      {
        _name: "CSidebarNavItem",
        name: "Message",
        icon: "cil-pencil",
        to: "/message",
      },
      {
        _name: "CSidebarNavItem",
        name: "Ad Rewards",
        icon: "cil-pencil",
        to: "/adRewards",
      },

      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Stakelist',
      //   icon: 'cil-notes',
      //   to: '/stakingCoin'
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Capture CSVDownload',
      //   icon: 'cil-notes',
      //   to: '/csvDownload'
      // },
      // {
      //   _name: 'CSidebarNavTitle',
      //   _children: ['NFT ']
      // },
      // {
      //   _name: 'CSidebarNavItem',
      //   name: 'Card Details ',
      //   icon: 'cil-pencil',
      //   to: '/cardDetails'
      // },
    ],
  },
];
